import React from 'react';
import { Section, FadeIn } from './ui';
export const FailedSolutionsSection = () => {
  const attempts = [{
    icon: '😮‍💨',
    title: '"Voy a descansar más"',
    result: 'La culpa no te dejó descansar de verdad'
  }, {
    icon: '🧘',
    title: '"Voy a hacer yoga o meditación"',
    result: 'Lo hiciste 3 días y la vida te arrolló de nuevo'
  }, {
    icon: '📱',
    title: '"Vi videos motivacionales"',
    result: 'Te sentiste bien 20 minutos y volvió todo'
  }, {
    icon: '💬',
    title: '"Le conté a una amiga"',
    result: 'Se desahogó ella también y quedaste igual'
  }, {
    icon: '📚',
    title: '"Leí libros de autoayuda"',
    result: 'Eran muy teóricos — no hablaban de TU vida real'
  }];
  return <Section className="bg-cream-100" data-id="element-56">
      <FadeIn data-id="element-57">
        <h2 className="text-2xl sm:text-4xl mb-2 sm:mb-4 text-center text-navy-900" data-id="element-58">
          Por Qué las Soluciones de Siempre No Funcionan
        </h2>
        <p className="text-lg sm:text-xl text-center text-gray-600 mb-6 sm:mb-12" data-id="element-59">
          Quizás ya lo intentaste:
        </p>

        <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-16" data-id="element-60">
          {attempts.map((item, i) => <div key={i} className="bg-white rounded-xl p-4 sm:p-6 shadow-sm flex flex-col sm:flex-row gap-2 sm:gap-4 sm:items-center border border-cream-200" data-id="element-61">
              <div className="flex items-center gap-3 sm:gap-4 sm:w-1/2" data-id="element-62">
                <span className="text-2xl sm:text-3xl" data-id="element-63">{item.icon}</span>
                <span className="text-base sm:text-lg font-medium text-navy-800" data-id="element-64">
                  {item.title}
                </span>
              </div>
              <div className="sm:w-1/2 text-gray-600 italic" data-id="element-65">{item.result}</div>
            </div>)}
        </div>

        <div className="text-center bg-rose-50 rounded-xl sm:rounded-2xl p-5 sm:p-8 border border-rose-100" data-id="element-66">
          <p className="text-xl sm:text-2xl text-navy-900 font-medium" data-id="element-67">
            El problema no eras tú.
          </p>
          <p className="text-lg sm:text-xl text-gray-700 mt-2" data-id="element-68">
            El problema era que ninguna de esas cosas iba a la raíz de lo que
            realmente pasa.
          </p>
        </div>
      </FadeIn>
    </Section>;
};